import { render } from "./GoalsBlock.vue?vue&type=template&id=d293c6e2&scoped=true"
import script from "./GoalsBlock.vue?vue&type=script&lang=js"
export * from "./GoalsBlock.vue?vue&type=script&lang=js"

import "./GoalsBlock.vue?vue&type=style&index=0&id=d293c6e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d293c6e2"]])

export default __exports__